module.exports = __webpack_public_path__ + "img/account-en.08116e00.png";